import React, { useEffect, useRef, useState } from 'react';
import { FORMAT_DATE } from 'common/constants';
import { filter, find } from 'lodash';
import moment from 'moment-timezone';
import './style.scss';

export default function (props: {
  defaultValue?: any;
  value?: any;
  label: string;
  color?: string;
  primary?: boolean;
  lightPrimary?: boolean;
  mappingData?: any;
  isDate?: boolean;
  formartDate?: string;
  hightLabel?: boolean;
}) {
  const {
    defaultValue,
    value: nextValue,
    label,
    primary,
    lightPrimary,
    color,
    mappingData,
    isDate,
    formartDate,
    hightLabel = false,
  } = props;
  const currentValue = useRef(nextValue);
  const [value, setValue] = useState(nextValue || defaultValue);
  useEffect(() => {
    if (nextValue !== undefined && currentValue.current !== nextValue) {
      setValue(nextValue);
      currentValue.current = nextValue;
    }
  }, [nextValue]);

  const transferData = (data: any, oldValue: any) => {
    const newValue = find(data, (item: any) => {
      const compareValue = item.id || item.value;
      return compareValue === oldValue;
    });
    return newValue?.label || oldValue;
  };

  const convertData = (oldValue: any) => {
    if (isDate && oldValue) {
      const newValue = moment(oldValue).local().format(formartDate);
      return newValue ? newValue : '';
    }
    return oldValue ? oldValue : '';
  };

  return (
    <div className="text-field">
      <div className={`text-label ${hightLabel ? 'text-label-height' : ''}`}>
        {label}
      </div>
      <div
        className={`text-description ${
          primary ? 'primary' : lightPrimary ? 'light-primary' : ''
        }`}
        style={{ color }}
      >
        {mappingData ? transferData(mappingData, value) : convertData(value)}
      </div>
    </div>
  );
}
